import React from 'react';
import { Container } from 'reactstrap';
import AwardingList from '../Awarding/components/AwardingList';

const AwardingSupplierPage = () => {
  document.title = 'Awarding';

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <AwardingList
            endpoint='/awarding/supplier'
            detailBasePath='/apps-awarding-supplier/dtl'
            viewPath='/apps-awarding-supplier/view'
            subtitle='Review awardings issued to you and follow their confirmation status.'
            canCreate={false}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AwardingSupplierPage;
